<template>
    <form-select
        placeholder="年"
        selectName="year"
        :optionList="setOptions(startYear,endYear)"
        v-model="year"
        :value="yearValue"
        :blur-event="onBlur"
        data-jest="select-year"
    />
</template>

<script>
import FormSelect from "../atoms/FormSelect.vue";
export default {
    name: "InputProfileItemYear",
    components: {FormSelect},
    props: {
        /**
         * storeのyear
         */
        yearValue: {
            type: String,
            required: true
        },
        /**
         * 入力値が空か
         * blur時のバリデーション判定用
         */
        isEmpty: {
            type: Boolean,
            required: true
        },
        /**
         * セレクトボックスで表示する最初の年の値
         */
        startYear: {
            type: Number,
            required: true
        },
        /**
         * セレクトボックスで表示する最後の年の値
         */
        endYear: {
            type: Number,
            required: true
        },
    },
    emits: ['input'],
    computed: {
        year: {
            get() {
                return this.yearValue
            },
            set(value) {
                return this.emit(value.toString());
            }
        },
        isEmptyYear: {
            get() {
                return this.isEmpty
            },
            set() {
                return this.emit(this.year);
            }
        },
    },
    methods: {
        /**
         * 引数の範囲でoptionを生成する
         * startからlastまでの数字の配列を作る
         */
        setOptions(start, last) {
            let list = [];
            if (start < last) {
                for(let i = start; i <= last; i++) {
                    list.push({id: `${i}`, label: `${i}`})
                }
            } else {
                for(let i = start; last <= i; i--) {
                    list.push({id: `${i}`, label: `${i}`})
                }
            }
            return list;
        },
        /**
         * blur時に年の入力値の有無をチェックする
         */
        onBlur() {
            this.isEmptyYear = !this.yearValue;
        },
        /**
         * 親にemitする共通メソッド
         */
        emit(yearValue) {
            this.$emit("input", yearValue.toString());
        },
    },
}
</script>
